import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { patchCryptoLink } from 'redux/crypto-links/actions';

import CommonLinkCheckbox from 'components/common/link-elements/CommonLinkCheckbox';

import './CryptoLinkIsPublished.css';


function CryptoLinkIsPublished(props) {
  const { linkItem, patchCryptoLink, expandedContent } = props;

  return (
    <div className="crypto-link-is-published__component">
      {expandedContent &&
        <div className="label">Hide Crypto</div>
      }
      <CommonLinkCheckbox
        key={`crypto-link-is-published-checkbox-key-${linkItem.id}`}
        linkId={linkItem.id}
        initialValue={linkItem.is_published}
        parameter="is_published"
        patchFunction={patchCryptoLink}
      />
    </div>
  );
}

CryptoLinkIsPublished.propTypes = {
  patchCryptoLink: PropTypes.func.isRequired,
  linkItem: PropTypes.object.isRequired,
  expandedContent: PropTypes.bool,
};

CryptoLinkIsPublished.defaultProps = {
  expandedContent: null,
};

export default connect(
  null,
  {
    patchCryptoLink,
  },
)(CryptoLinkIsPublished);
